import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useLocalParticipant, useDevices, useDaily } from '@daily-co/daily-react';
import {
  pageAtom,
  myNftAtom,
  myNftBackAtom,
  isAuthAtom,
  displayNameAtom,
  topMessageAtom,
} from '../../State';
import { useRecoilState } from 'recoil';
import { ReactComponent as CloseSVG } from '../Images/buttons/closeWhiteButton.svg';
import MetaMaskButton from '../Images/buttons/connectMetaMaskButton.png';
import './ElectronMetaMask.css';
import DataModel from '../Util/DataModel';
import Loading from '../Loading/Loading';
import { useTranslation } from 'react-i18next';

export default function ElectronMetaMaskLogin({ setShowMetamaskLogin, getWalletAddress }) {
  const callObject = useDaily();

  //Recoil系
  const [pageState, setPageState] = useRecoilState(pageAtom);
  const [isAuthState, setAuthState] = useRecoilState(isAuthAtom);
  const [topMessageState, setTopMessageState] = useRecoilState(topMessageAtom);

  //その他
  const codeValue = useRef('');
  const [loadingState, setLoadingState] = useState(false);
  const { t } = useTranslation();

  //urlの入力エリア
  const onCodeChange = (e) => {
    codeValue.current = e.target.value;
  };

  //オープンブラウザ
  const openBrowser = async () => {
    const buff = await window.myapi.openLink('https://faceless.ooo/metamask');
  };

  //認証
  const verify = async () => {
    if (codeValue.current == '' || codeValue.current == null) return;
    //ローディング開始
    setLoadingState(true);

    //コードからトークンとユーザー情報を取得
    const address = await DataModel.getAddressFromCode(codeValue.current);

    //ローディング終了
    setLoadingState(false);

    //エラーがある場合
    if (address == null) {
      setTopMessageState({
        type: 'joined',
        message: t('electron.There is an error'),
      });
    } else {
      //ログイン成功
      setTopMessageState({
        type: 'joined',
        message: t('electron.Verified!'),
      });

      //ローカルデータに保存
      localStorage.setItem('isMetaMaskConnected', true);

      //画面を閉じる
      setShowMetamaskLogin(false);

      //親のファンクションをコール
      getWalletAddress();
    }
  };

  //背景をタップ時
  const tapBack = () => {
    setShowMetamaskLogin(false);
  };

  //レンダービュー
  const renderScreen = () => {
    return (
      <>
        {/*　ローディング */}
        <div id="isElectron">
          <Loading loadingState={loadingState} />
        </div>
        <div id="electronBackWrap" onClick={tapBack}></div>
        <div id="electronTopWrap">
          <div id="nftTitle">
            {t('electron.Login with MetaMask')}
            <div id="nftCloseButton">{/* <CloseSVG onClick={tapBack} /> */}</div>
          </div>

          <div id="electronMetaWrap">
            <div style={{ textAlign: 'center' }}>
              <img src="./images/header/metaMask.svg" />
            </div>
            <div className="electronH1">
              <span className="electronNumber">1.</span>{' '}
              {t('electron.Open the link below using Browser & connect to MetaMask')}
            </div>
            <div className="electronAreaWrap">
              <div id="electronURL">https://faceless.ooo/metamask </div>
              <div id="electronOpen">
                <button onClick={openBrowser}>{t('electron.Open browser')}</button>
              </div>
            </div>
            <div className="electronH1">
              <span className="electronNumber">2.</span>{' '}
              {t('electron.Paste the verificartion code below')}
            </div>

            <div className="electronAreaWrap">
              <input
                type="text"
                placeholder={t('electron.paste verification code')}
                onChange={(e) => onCodeChange(e)}
              />

              <div id="electroyVerify">
                <button onClick={verify}>{t('electron.Verify')}</button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return renderScreen();
}
